<template>
  <div class="col-12 col-sm-6 col-md-4">
    <div class="card" :class="{'bg-light': order.status == 'processing', 'bg-success-soft': order.status == 'confirmed'}">
      <div class="card-header">
        <h3 class="card-header-title me-auto">Pedido #{{ order.id }}</h3>
        <h3 class="mb-0" :data-tooltip="`Tempo em aberto: ${zeroPrefix(clock.hours, 2)}:${zeroPrefix(clock.minutes, 2)}`"><span class="badge bg-primary-soft">{{ `${zeroPrefix(clock.hours, 2)}:${zeroPrefix(clock.minutes, 2)}` }}</span></h3>
      </div>
      <div class="card-body py-3">
        <div class="row align-items-center">
          <div class="col">
            <h5 class="mb-0 mt-0">{{ statuses.find(item => item.value == order.status).label }}</h5>
          </div>
          <div class="col-auto">
            <button v-if="order.status == 'confirmed'" class="btn btn-outline-primary btn-sm" @click="changeStatus('processing')">Iniciar</button>
            <button v-else class="btn btn-success btn-sm" @click="changeStatus('waiting')">Finalizar</button>
          </div>
        </div>
      </div>
      <div class="card-no-body">
        <table class="table table-sm">
          <colgroup>
            <col style="width:15%">
          </colgroup>
          <thead>
            <tr>
              <th>Qtd</th>
              <th>Produto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in order.products" :key="product.id">
              <td>{{ product.quantity }}</td>
              <td>
                <p class="mb-0">{{ product.product_name }}</p>
                <small v-if="product.additionals" class="text-muted">Adicionais: {{ product.additionals }}</small>
                <small v-if="product.observations" class="text-muted"><br>Observações: {{ product.observations }}</small>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatus } from '../../helpers/status.js'

export default {
  props: {
    order: { type: Object, default: null }
  },
  data() {
    return {
      statuses: getStatus('delivery'),
      clock: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      }
    }
  },
  methods: {
    count() {
      const timeElapsed = new Date(new Date() - this.startTime)
      this.clock.hours = timeElapsed.getUTCHours()
      this.clock.minutes = timeElapsed.getUTCMinutes()
      this.clock.seconds = timeElapsed.getUTCSeconds()
    },
    zeroPrefix(num, digit) {
      var zero = '';

      for(var i = 0; i < digit; i++) {
        zero += '0';
      }

      return (zero + num).slice(-digit);
    },
    changeStatus(status) {
      this.$store.dispatch('orders/updateStatus', { id: this.order.id, status })
        .then(() => {
          this.$store.dispatch('orders/updateOrders');
        });
    }
  },
  mounted() {
    this.startTime = new Date(this.order.created_at);

    clearInterval(this.interval);
    this.interval = setInterval(this.count, 10 * 1000);
    this.count();
  },
  destroyed() {
    clearInterval(this.interval);
  }
}
</script>
